// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-icon-chat[data-v-3e9b332f]{background:#e1e2e7;border-radius:10.4px;padding:10px}.icon-dot[data-v-3e9b332f]{position:absolute;margin-top:-6px;margin-left:-4px}", ""]);
// Exports
module.exports = exports;
